export const WA_NUMBER = "393510741289";

export const waLink = (text) =>
  `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(text)}`;

export const engineWaLink = (engine) => {
  const price = engine.price
    ? `€${engine.price.toLocaleString("it-IT")}`
    : "prezzo da concordare";
  const km = engine.mileage
    ? ` — ${engine.mileage.toLocaleString("it-IT")} km`
    : "";
  const text = `Salve Delta R.E.M., sono interessato al motore ${engine.code} (${engine.title}) a ${price}${km}. Potete confermarmi la disponibilità?`;
  return waLink(text);
};
